module.exports = __webpack_public_path__ + "img/1.61fabc6a.png";